import classNames from 'classnames'
import React, { useState } from 'react'
import { Permission } from 'settings/schema'
import { getDependentPermissions, getPrerequisitePermissions, PERMISSION_DEFINITIONS } from '../schema'
import ToggleFieldFormik from 'uiComponents/input/toggle/toggleFieldFormik'

interface PermissionToggleProps {
    permission: Permission
    disabled?: boolean
    handleClick?: (permission: Permission, granted: boolean) => void
}

export const PermissionToggle = ({ permission, disabled, handleClick }: PermissionToggleProps) => {
    const [justToggled, setJustToggled] = useState(false)

    return (
        <ToggleFieldFormik
            name={`permissions.${permission}`}
            label={PERMISSION_DEFINITIONS[permission].label()}
            className={classNames('toggle', { disabled: disabled, 'just-toggled': justToggled }, [
                permission,
                ...getDependentPermissions(permission).map((permission) => `dependent-${permission}`),
                ...getPrerequisitePermissions(permission).map((permission) => `prerequisite-${permission}`),
            ])}
            disabled={disabled}
            onClick={(granted) => {
                setJustToggled(true)
                handleClick?.(permission, granted)
            }}
            onMouseLeave={() => setJustToggled(false)}
        />
    )
}
